<template>
  <el-dialog v-dialog-drag :title="title" :width="width" :visible="visible" :close-on-click-modal="false" @close="handleClose">
    {{ confimMsg }}
    <div slot="footer" class="dialog-footer">
      <el-button  @click="handleClose">取消</el-button>
      <el-button type="danger" @click="continueDel" :loading="loading">继续删除</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { submit } from "@/api/base";
import { baseURL, successCode } from "@/config";
import useRouter from 'vue-router'
export default {
  name: "comfirmDel",
  data() {
    return {
      confimMsg: "",
      visible: false,
      width: "400px",
      title: "提示",
      productIDs: "",
      loading:false
    };
  },
  methods: {
    open(msg, productIDs) {
      this.confimMsg = msg;
      this.productIDs = productIDs;
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
    async continueDel() {
      this.loading = true;
      const result = await submit('/api/product/Delete', {
        ProductIDs: this.productIDs,
        ConfirmDelFlag:true
      });
      if (result.success) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.$emit("handleRefresh");
        this.loading = false;
        this.handleClose();
      }
    },
    async toDealData() {

      this.handleClose();

      this.$emit("handleDrawer");
      // sessionStorage.setItem('productIDs', this.productIDs);
      // this.$router.push({
      //   path: '/stall/cashier',
      //   query: {
      //     searchProduct: 1
      //   }
      // })
      // Vue 3 组合式API
      // const routeUrl = this.$router.resolve({
      //   path: '/stall/cashier',
      //   query: { searchProduct: 1 }
      // })
      //  window.open(routeUrl.href, '_blank');
      //window.open('#/stall/cashier?searchProduct=1', '_blank')
    },
  },
};
</script>
<style scoped>
.xls-import {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.xls-import .btn-wrap {
  margin-top: 10px;
}
</style>
